import actions from '@/store/modules/tags/actions';
import mutations from '@/store/modules/tags/mutations';
import { ascending } from '@/utils/tools';

const moduleTags = {
  namespaced: true,

  state: {
    realms: {},

    input: '',
    focusedRealm: null,
    listLoading: false,
    add_realm: {
      input: '',
      minlength: 3,
      maxlength: 25,
      regex: /^[\w]+$/,
    },
    details: {
      input: '',
      minlength: 3,
      maxlength: 25,
      regex: /^[\w]+$/,
    },
  },
  getters: {
    sortedRealms({ realms }) {
      return Object.values(realms).sort((a, b) => ascending(a.name, b.name));
    },
    tagList(state) {
      const realm = state.realms[state.focusedRealm];
      if (realm) {
        return realm.tags.sort((a, b) => ascending(a.name, b.name));
      }

      return [];
    },
  },
  actions: {
    ...actions,
  },
  mutations: {
    ...mutations,
  },
  modules: {},
};

export default moduleTags;
